<script lang="ts">
import "@cisco-u/icons/icons/cu-icon-close-x.js";

import { defineComponent } from "vue";

export default defineComponent({
  emits: ["close-genai-model"],
  props: {
    showBgImage: {
      type: Boolean,
      default: false,
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
    showAcceptNext: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<template>
  <div
    class="mx-auto my-0 overflow-hidden rounded-t-lg border border-b-0 border-black-light bg-black-dark py-5 dark:bg-black"
  >
    <div class="modal-header">
      <div class="flex items-center justify-between text-black dark:text-white">
        <div class="relative m-auto w-full items-center text-center">
          <button
            v-if="showCloseIcon"
            tabindex="0"
            data-cy="close-goal-modal"
            class="transformscale-y absolute right-6 top-[0.4375rem] flex w-full cursor-pointer flex-row justify-end text-11 text-white-lightest"
            @click.prevent="$emit('close-genai-model')"
            @keyup.enter.prevent="$emit('close-genai-model')"
            @keyup.space.prevent="$emit('close-genai-model')"
          >
            <cu-icon-close-x size="sm" class="mb-2" />
          </button>
          <div
            class="m-auto my-2 flex items-center justify-center gap-4 w-full"
          >
            <img
              src="@/layout/GenAIBeta/assets/cisco_ai_assistant.png"
              alt="AI prompt icon"
              class="w-[1.75rem]"
            />
            <cu-logo type="small" width="5rem"></cu-logo>
          </div>
          <div v-if="showBgImage" class="absolute top-[-1.375rem] lefy-0">
            <span>
              <img
                src="@/layout/GenAIBeta/assets/confetti_shapes_left.png"
                alt="Gen AI Icon"
                class="h-50 w-50"
              />
            </span>
          </div>
          <div v-if="showBgImage" class="absolute bottom-[-1.375rem] right-0">
            <span>
              <img
                src="@/layout/GenAIBeta/assets/confetti_shapes_right.png"
                alt="Gen AI Icon"
                class="h-50 w-50"
              />
            </span>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
